/* Vari Designs - search overlay.
   The bracket demo is deliberately CSS-only (hidden checkbox in vari-core.css),
   so it cannot break on script load order, caching, or click interception. */
(function () {
  'use strict';

  /* nearest matching ancestor, safe on SVG children too */
  function up(node, selector) {
    while (node && node !== document) {
      if (node.nodeType === 1 && node.matches && node.matches(selector)) return node;
      node = node.parentNode;
    }
    return null;
  }

  function initSearch() {
    var overlay = document.getElementById('vari-search');
    if (!overlay || overlay.dataset.init === '1') return;
    overlay.dataset.init = '1';

    var input    = overlay.querySelector('[data-vs-input]');
    var results  = overlay.querySelector('[data-vs-results]');
    var closeEl  = overlay.querySelector('[data-vs-close]');
    var backdrop = overlay.querySelector('[data-vs-backdrop]');
    var lastFocus = null;
    var timer = null;

    function open(e) {
      if (e) e.preventDefault();
      lastFocus = document.activeElement;
      overlay.classList.add('vs-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 60);
    }

    function close() {
      overlay.classList.remove('vs-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var a = up(e.target, 'a[href]');
      if (!a) return;
      if (a.hasAttribute('data-vs-ignore')) return;
      var href = a.getAttribute('href') || '';
      if (/\/search(\/|\?|$)/.test(href)) open(e);
    });

    if (closeEl)  closeEl.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (!e.key) return;
      if (e.key === 'Escape' && overlay.classList.contains('vs-open')) close();
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); open(); }
    });

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function formatMoney(cents) {
      var n = (parseInt(cents, 10) / 100).toFixed(2);
      return (overlay.dataset.currency || '$') + n;
    }

    function render(items, query) {
      if (!results) return;
      if (!items.length) {
        results.innerHTML = '<div class="vs-hint">No matches for “' + escapeHtml(query) + '”.</div>';
        return;
      }
      var html = items.map(function (it) {
        var img = it.featured_image && it.featured_image.url
          ? '<img src="' + it.featured_image.url + '" alt="" loading="lazy">'
          : '<div class="vs-item-ph"></div>';
        return '<a class="vs-item" href="' + it.url + '">' + img +
               '<div><div class="vs-item-t">' + escapeHtml(it.title) + '</div>' +
               '<div class="vs-item-p">' + (it.price ? formatMoney(it.price) : '') + '</div></div></a>';
      }).join('');
      html += '<a class="vs-all" href="/search?q=' + encodeURIComponent(query) + '" data-vs-ignore>See all results</a>';
      results.innerHTML = html;
    }

    function search(q) {
      if (!results) return;
      results.innerHTML = '<div class="vs-hint">Searching…</div>';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last',
            { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var items = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(items, q);
        })
        .catch(function () {
          results.innerHTML = '<div class="vs-hint">Search is unavailable right now.</div>';
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) {
          if (results) results.innerHTML = '<div class="vs-hint">Start typing to search products.</div>';
          return;
        }
        timer = setTimeout(function () { search(q); }, 220);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var q = input.value.trim();
          if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearch);
  } else { initSearch(); }

  document.addEventListener('shopify:section:load', initSearch);
})();
